class Variables {
  protected employeesDefinition = {
    davis: {
      name: 'Davis Laquaye',
      email: 'davis@totocars.com',
      phone: '0032 (0)465 26 08 57',
      plainPhone: '+32465260857',
    },
    toto: {
      name: 'Toto Rasoyan',
      email: 'toto@totocars.com',
      phone: '0032 (0)471 03 04 05',
      plainPhone: '+32471030405',
    },
  };

  protected addressDefinition = {
    street: 'Kortrijkstraat 90',
    city: '8550 Zwevegem',
    country: 'België',
  };

  protected instagramDefinition = [
    'totocars',
    'toto_cars',
  ];

  protected languagesDefinition = [
    {
      code: 'fr',
      name: 'Français',
    },
    {
      code: 'nl',
      name: 'Nederlands',
    },
    {
      code: 'en',
      name: 'English',
    },
  ];

  protected vatDefinition = 21;

  get employees() {
    return this.employeesDefinition;
  }

  get address() {
    return this.addressDefinition;
  }

  get instagram() {
    return this.instagramDefinition;
  }

  get languages() {
    return this.languagesDefinition;
  }

  get vat() {
    return this.vatDefinition;
  }
}

const variables = new Variables();

export default variables;
